class IdleTimer {
    constructor({ timeOut, onTimeOut, onExpired }) {
        this.timeOut = timeOut;
        this.onTimeOut = onTimeOut;
        this.onExpired = onExpired;
        const expiredTime = parseInt(localStorage.getItem("_expiredTime") || 0, 10);
        if (expiredTime > 0 && expiredTime < Date.now()) {
            return this.onExpired();
        }
        this.eventHandler = this.updateExpiredTime.bind(this);
        this.tracker();
        this.startInterval();
    }

    startInterval() {
        this.updateExpiredTime();
        this.interval = setInterval(() => {
            const expiredTime = parseInt(localStorage.getItem("_expiredTime") || 0, 10);
            if (expiredTime < Date.now() && this.onTimeOut) {
                this.onTimeOut();
                this.cleanUp();
            }
        }, 1000);
    }
    updateExpiredTime() {
        if (this.timeOutTracker) {
            clearTimeout(this.timeOutTracker);
        }
        this.timeOutTracker = setTimeout(() => {
            localStorage.setItem("_expiredTime", Date.now() + this.timeOut * 1000);
        }, 300);
    }
    tracker() {
        window.addEventListener("mousemove", this.eventHandler);
        window.addEventListener("keydown", this.eventHandler);
        window.addEventListener("scroll", this.eventHandler);
    }
    cleanUp() {
        localStorage.removeItem("_expiredTime");
        clearInterval(this.interval);
        window.removeEventListener("mousemove", this.eventHandler);
        window.removeEventListener("keydown", this.eventHandler);
        window.removeEventListener("scroll", this.eventHandler);
    }
}

export default IdleTimer;
